var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.01,89.302L273.876,3.673C268.215,1.235,262.201,0,256,0c-6.191,0-12.195,1.235-17.876,3.673 L37.991,89.302c-16.74,7.161-27.564,23.558-27.564,41.777v249.853c0,18.21,10.824,34.606,27.564,41.777l200.143,85.628 C243.815,510.766,249.819,512,256,512c6.18,0,12.186-1.234,17.876-3.663l200.134-85.628c16.739-7.171,27.563-23.567,27.563-41.777 V131.078C501.573,112.86,490.749,96.462,474.01,89.302z M41.027,380.932V131.078c0-1.313,0.176-2.616,0.539-3.899l205.785,88.048 V479.01L50.038,394.587C44.563,392.246,41.027,386.878,41.027,380.932z M461.962,394.587L264.659,479.01V215.228l205.776-88.048 c0.363,1.283,0.538,2.586,0.538,3.899v249.853C470.973,386.878,467.437,392.246,461.962,394.587z M256,30.6 c2.018,0,3.987,0.401,5.828,1.195l193.776,82.906L256,200.104L56.395,114.701l193.767-82.906C252.014,31.001,253.982,30.6,256,30.6 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.e17d389a110206fb039ec3f1efbbd51a.svg";
export { ForwardRef as ReactComponent };